export default "__VITE_ASSET__BIDrTiq7__"